/**
 * Link de compartilhamento: endereco absoluto da rota + `ts` (epoch, em
 * segundos) do momento do clique.
 *
 * Rede social guarda a previa por URL. Com o `ts`, cada compartilhamento e uma
 * URL nova e a previa e montada de novo pelo backend (que tambem repete o `ts`
 * no `og:url` — ver `photoe/views/spa.py`). Gere o link NA HORA do clique,
 * nunca no render, para o carimbo ser o do compartilhamento.
 */
export function shareUrl(path, params = {}) {
  const url = new URL(path, window.location.origin);
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") url.searchParams.set(key, value);
  });
  url.searchParams.set("ts", Math.floor(Date.now() / 1000));
  return url.toString();
}

export default shareUrl;
